import { render } from "./NotFound.vue?vue&type=template&id=8b6bc292&scoped=true&ts=true"
import script from "./NotFound.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotFound.vue?vue&type=script&setup=true&lang=ts"

import "./NotFound.vue?vue&type=style&index=0&id=8b6bc292&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src231289078/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b6bc292"],['__file',"src/components/sgre/NotFound.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8b6bc292"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8b6bc292', __exports__)) {
    console.log('reload')
    api.reload('8b6bc292', __exports__)
  }
  
  module.hot.accept("./NotFound.vue?vue&type=template&id=8b6bc292&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('8b6bc292', render)
  })

}


export default __exports__